import { CSSProperties } from "@material-ui/core/styles/withStyles";
import React, { useState } from "react";
import Home from "./Home";
import Publicaciones from "./Publicaciones";
import Graficas from "./Graficas";
import MediosReportes from "./MediosReportes";
import Salas from "./Salas";
import Plataformas from "./Plataformas";
import home from "../../assets/images/home.png";
import newspaper from "../../assets/images/newspaper.png";
import plot from "../../assets/images/plot.png";
import website from "../../assets/images/website.png";
import sala from "../../assets/images/sala.png";
import consulta from "../../assets/images/consulta.png";
import "../styles/Navbar.styles.scss";
import PIETooltip from "./PIETooltip";

interface NavBarProps {
  parentState: any;
  setParentState: any;
}

const NavBar = (props: NavBarProps) => {
  const { setParentState } = props;

  const [active, setActive] = useState(false);
  const [option, setOption] = useState(1);

  const activateMenu = () => {
    setActive(!active);
    document.getElementById("circlenav")?.classList.toggle("is-active");
    document.getElementById("ccirclenavtoggle")?.classList.toggle("is-active");
    document.getElementById("cmask")?.classList.toggle("is-active");
  };

  const animations: CSSProperties[] = [
    {
      transform: "translate(-144px)",
      transitionDelay: "0.4s",
      opacity: 1,
    },
    {
      transitionDelay: ".1s",
      transform: "translate(-134px,-56px)",
      opacity: 1,
    },
    {
      transitionDelay: ".2s",
      transform: "translate(-102px,-102px)",
      opacity: 1,
    },
    {
      transitionDelay: ".3s",
      transform: "translate(-56px,-134px)",
      opacity: 1,
    },
    {
      transitionDelay: ".4s",
      transform: "translateY(-144px)",
      opacity: 1,
    },
  ];

  const handleComponent = (component: JSX.Element, option: number) => {
    setOption(option);
    setParentState(component);
  };

  return (
    <>
      {/* <nav className="c-circle-nav" id="ccirclenav" onClick={activateMenu}>
        <button className="c-circle-nav__toggle" id="ccirclenavtoggle">
          <span>Toggle</span>
        </button>
        <ul className="c-circle-nav__items">
          {option === 1 ? null : (
            <PIETooltip
              title={"Información relevante"}
              icon={
                <li
                  className="c-circle-nav__item"
                  style={active ? animations[0] : {}}
                  onClick={() => handleComponent(<Home />, 1)}
                >
                  <a href="#home" className="c-circle-nav__link">
                    <img src={home} alt="" />
                  </a>
                </li>
              }
              placement="left"
            />
          )}
          {option === 2 ? null : (
            <PIETooltip
              title={"Últimas publicaciones"}
              icon={
                <li
                  className="c-circle-nav__item"
                  style={active ? animations[option === 1 ? 0 : 1] : {}}
                  onClick={() => handleComponent(<Publicaciones />, 2)}
                >
                  <a href="#publicaciones" className="c-circle-nav__link">
                    <img src={newspaper} alt="" />
                  </a>
                </li>
              }
              placement="left"
            />
          )}
          {option === 3 ? null : (
            <PIETooltip
              title={"Gráficas"}
              icon={
                <li
                  className="c-circle-nav__item"
                  style={active ? animations[option <= 2 ? 1 : 2] : {}}
                  onClick={() => handleComponent(<Graficas />, 3)}
                >
                  <a href="#graficas" className="c-circle-nav__link">
                    <img src={plot} alt="" />
                  </a>
                </li>
              }
              placement={option <= 2 ? "left" : "left-start"}
            />
          )}
          {option === 4 ? null : (
            <PIETooltip
              title={
                "Conoce los medios de impugnación / Consulta los reportes estadísticos"
              }
              icon={
                <li
                  className="c-circle-nav__item"
                  style={active ? animations[option <= 3 ? 2 : 3] : {}}
                  onClick={() => handleComponent(<MediosReportes />, 4)}
                >
                  <a href="#consulta" className="c-circle-nav__link">
                    <img src={consulta} alt="" />
                  </a>
                </li>
              }
              placement={option <= 3 ? "left" : "left-start"}
            />
          )}
          {option === 5 ? null : (
            <PIETooltip
              title={"Salas"}
              icon={
                <li
                  className="c-circle-nav__item"
                  style={active ? animations[option <= 4 ? 3 : 4] : {}}
                  onClick={() => handleComponent(<Salas />, 5)}
                >
                  <a href="#salas" className="c-circle-nav__link">
                    <img src={sala} alt="" />
                  </a>
                </li>
              }
              placement={"left-start"}
            />
          )}
          {option === 6 ? null : (
            <PIETooltip
              title={"Plataformas jurisdiccionales"}
              icon={
                <li
                  className="c-circle-nav__item"
                  style={active ? animations[4] : {}}
                  onClick={() => handleComponent(<Plataformas />, 6)}
                >
                  <a href="#plataformas" className="c-circle-nav__link">
                    <img src={website} alt="" />
                  </a>
                </li>
              }
              placement={"top"}
            />
          )}
        </ul>
      </nav>
      <div id="cmask" className="c-mask"></div> */}
    </>
  );
};

export default NavBar;
